import { render, staticRenderFns } from "./sendWhatsMobile.vue?vue&type=template&id=6a598eac&scoped=true&"
import script from "./sendWhatsMobile.vue?vue&type=script&lang=js&"
export * from "./sendWhatsMobile.vue?vue&type=script&lang=js&"
import style0 from "./sendWhatsMobile.vue?vue&type=style&index=0&id=6a598eac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a598eac",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VDivider,VForm})
